import React from "react"
import styled from "styled-components"

const ProductImageCard = ({ productImage }) => {
  return (
    <ProductImageBox>
      <MainImage src={productImage} />
    </ProductImageBox>
  )
}

export default ProductImageCard

const ProductImageBox = styled.div`
  display: flex;
  width: 45%;
  height: 60vh;
  border-radius: 10px;
  @media (max-width: 768px) {
    width: 100%

  }
`

const MainImage = styled.img`
  border-radius: 10px;
  height: 100%;
  @media (max-width: 768px) {
    max-width: 100%;

  }
`
